export const LICENSE_TYPE_DEFS = {
    app: {
        key: 'apps',
        label: 'application',
    },
    desktop: {
        key: 'computers',
        label: 'user',
    },
    epub: {
        key: 'ebooks',
        label: 'publication',
    },
    web: {
        key: 'views',
        label: 'page views per month',
        short: 'views',
    },
};